import { render } from "./NewsMore.vue?vue&type=template&id=53515421&scoped=true"
import script from "./NewsMore.vue?vue&type=script&lang=js"
export * from "./NewsMore.vue?vue&type=script&lang=js"

import "./NewsMore.vue?vue&type=style&index=0&id=53515421&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53515421"]])

export default __exports__